(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monk-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initDrawerLanding(root){
    if(!root || root.dataset.dlInit) return;
    root.dataset.dlInit = "true";

    var revealEls = root.querySelectorAll('.dl-reveal');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('dl-in'); io.unobserve(e.target);} });
    },{threshold:0.15});
    revealEls.forEach(function(el){ io.observe(el); });

    var chart = root.querySelector('.dl-cortisol-chart');
    if(chart){
      var chartIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            chart.querySelectorAll('.dl-curve').forEach(function(path){
              var delay = parseInt(path.getAttribute('data-delay'));
              setTimeout(function(){ path.style.transition='stroke-dashoffset 1.6s ease'; path.style.strokeDashoffset='0'; }, delay);
            });
            chartIo.unobserve(chart);
          }
        });
      },{threshold:0.4});
      chartIo.observe(chart);
    }

    var bars = root.querySelectorAll('.dl-bar-fill');
    var barIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.style.width = e.target.getAttribute('data-width'); barIo.unobserve(e.target); }
      });
    },{threshold:0.3});
    bars.forEach(function(b){ barIo.observe(b); });

    var counters = root.querySelectorAll('[data-count]');
    var countIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var el = e.target;
          var target = parseInt(el.getAttribute('data-count'));
          var suffix = el.getAttribute('data-suffix') || '';
          var cur = 0;
          var step = Math.max(1, Math.ceil(target/30));
          var t = setInterval(function(){
            cur += step;
            if(cur >= target){ cur = target; clearInterval(t); }
            el.textContent = cur + suffix;
          }, 30);
          countIo.unobserve(el);
        }
      });
    },{threshold:0.5});
    counters.forEach(function(c){ countIo.observe(c); });

    root.querySelectorAll('.dl-faq-item').forEach(function(item){
      var answer = item.querySelector('.dl-faq-a');
      if(item.classList.contains('dl-open')){ answer.style.maxHeight = answer.scrollHeight + 'px'; }
      item.querySelector('.dl-faq-q').addEventListener('click', function(){
        var isOpen = item.classList.contains('dl-open');
        root.querySelectorAll('.dl-faq-item.dl-open').forEach(function(o){
          o.classList.remove('dl-open');
          o.querySelector('.dl-faq-a').style.maxHeight = 0;
        });
        if(!isOpen){ item.classList.add('dl-open'); answer.style.maxHeight = answer.scrollHeight + 'px'; }
      });
    });

    var stickyCta = root.querySelector('.dl-sticky-cta');
    var heroEl = root.querySelector('.dl-hero');
    if(stickyCta && heroEl){
      window.addEventListener('scroll', function(){
        var past = window.scrollY > heroEl.offsetHeight;
        stickyCta.classList.toggle('dl-show', past);
      });
    }
  }

  function initAll(scope){
    (scope || document).querySelectorAll('.dl-root').forEach(initDrawerLanding);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Re-init when Shopify's theme editor hot-swaps this section
  document.addEventListener('shopify:section:load', function(evt){
    initAll(evt.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monk-philosophy"] && !Shopify.designMode) return;
  try {
    
(function(){
const revealIO = new IntersectionObserver((entries)=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting){
      entry.target.classList.add('in-view');
      revealIO.unobserve(entry.target);
    }
  });
}, {threshold:0.15, rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.reveal').forEach(el=> revealIO.observe(el));

/* stagger within grids */
function staggerGroup(containerSel, ms){
  document.querySelectorAll(containerSel).forEach(container=>{
    Array.from(container.children).forEach((child,i)=>{
      if(child.classList && child.classList.contains('reveal')){
        child.style.transitionDelay = (i*ms)+'ms';
      }
    });
  });
}
staggerGroup('.research-grid', 100);
staggerGroup('.principle-grid', 100);
staggerGroup('.beyond-grid', 90);
staggerGroup('.formula-cards', 120);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-behind-monk"] && !Shopify.designMode) return;
  try {
    
(function(){
/* ---------------- shared helpers ---------------- */
function catmullRom2bezier(points){
  let d = `M ${points[0][0]} ${points[0][1]}`;
  for (let i=0;i<points.length-1;i++){
    const p0 = points[i===0?0:i-1];
    const p1 = points[i];
    const p2 = points[i+1];
    const p3 = points[i+2] || p2;
    const cp1x = p1[0] + (p2[0]-p0[0])/6;
    const cp1y = p1[1] + (p2[1]-p0[1])/6;
    const cp2x = p2[0] - (p3[0]-p1[0])/6;
    const cp2y = p2[1] - (p3[1]-p1[1])/6;
    d += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${p2[0]} ${p2[1]}`;
  }
  return d;
}
function fmtTime(hourFrom6am){
  let h = (6 + hourFrom6am) % 24;
  const ampm = h >= 12 ? 'PM' : 'AM';
  let hh = Math.floor(h % 12); if(hh===0) hh=12;
  const mm = Math.round((h%1)*60);
  return `${hh}:${mm.toString().padStart(2,'0')} ${ampm}`;
}

/* ---------------- HERO curve ---------------- */
const heroPts = [
  [0,140],[75,60],[150,20],[225,45],[300,80],[375,115],[450,145],[525,168],[600,172]
];
const heroPath = catmullRom2bezier(heroPts);
const heroLine = document.getElementById('heroLine');
const heroArea = document.getElementById('heroArea');
heroLine.setAttribute('d', heroPath);
heroArea.setAttribute('d', heroPath + ' L 600 210 L 0 210 Z');

const heroSvg = document.getElementById('heroSvg');
const heroDot = document.getElementById('heroDot');
const heroDotPulse = document.getElementById('heroDotPulse');
const heroScrub = document.getElementById('heroScrub');
const heroTimeEl = document.getElementById('heroTime');
const heroStateEl = document.getElementById('healthyReadoutState');

function heroPointAt(frac){
  const len = heroLine.getTotalLength();
  return heroLine.getPointAtLength(frac*len);
}
function updateHero(val){
  const frac = val/1000;
  const pt = heroPointAt(frac);
  heroDot.setAttribute('cx', pt.x);
  heroDot.setAttribute('cy', pt.y);
  heroDotPulse.setAttribute('cx', pt.x);
  heroDotPulse.setAttribute('cy', pt.y);
  const hourFrom6 = frac*24;
  heroTimeEl.textContent = fmtTime(hourFrom6);
  let state = 'Rising', prevPt = heroPointAt(Math.max(0,frac-0.02));
  if(pt.y < 35) state='Peak';
  else if(pt.y > prevPt.y+0.3) state='Declining';
  else if(pt.y > 150) state='Low';
  else if(pt.y < prevPt.y-0.3) state='Rising';
  else state='Steady';
  heroStateEl.textContent = state;
}
let heroTouched = false;
function stopHeroPulse(){
  if(heroTouched) return;
  heroTouched = true;
  heroDotPulse.classList.add('stopped');
}
heroScrub.addEventListener('input', e=>{ stopHeroPulse(); updateHero(e.target.value); });
heroScrub.addEventListener('pointerdown', stopHeroPulse);

/* draw the hero curve in on load, then reveal the dot + start the pulse cue */
const heroLen = heroLine.getTotalLength();
heroLine.style.strokeDasharray = heroLen;
heroLine.style.strokeDashoffset = heroLen;
heroArea.style.opacity = 0;
heroDot.style.opacity = 0;
heroDotPulse.style.opacity = 0;
updateHero(125);
window.addEventListener('load', ()=>{
  requestAnimationFrame(()=>{
    heroLine.style.transition = 'stroke-dashoffset 1.5s cubic-bezier(.16,.84,.44,1)';
    heroLine.style.strokeDashoffset = 0;
  });
  setTimeout(()=>{
    heroArea.style.transition = 'opacity 1.1s ease';
    heroArea.style.opacity = 1;
  }, 250);
  setTimeout(()=>{
    heroDot.style.transition = 'opacity .5s ease';
    heroDotPulse.style.transition = 'opacity .5s ease';
    heroDot.style.opacity = 1;
    heroDotPulse.style.opacity = 1;
  }, 1500);
  setTimeout(stopHeroPulse, 7000); /* auto-stop the invitation pulse after a while if untouched */
});

/* axis labels */
const axisG = document.getElementById('heroAxis');
['6AM','12PM','6PM','12AM','6AM'].forEach((lab,i)=>{
  const x = i*(600/4);
  const t = document.createElementNS('http://www.w3.org/2000/svg','text');
  t.setAttribute('x', x); t.setAttribute('y', 205); t.textContent = lab;
  if(i===0) t.setAttribute('text-anchor','start');
  else if(i===4) t.setAttribute('text-anchor','end');
  else t.setAttribute('text-anchor','middle');
  axisG.appendChild(t);
});
heroSvg.setAttribute('viewBox','0 0 600 210');

/* ---------------- FLIP toggle curve (morphing) ---------------- */
const flipData = {
  healthy: {pts:[[0,140],[75,60],[150,20],[225,45],[300,80],[375,115],[450,145],[525,168],[600,172]], color:[217,164,65], callout:'peaks once, drops fully'},
  common:  {pts:[[0,110],[75,90],[150,72],[225,85],[300,90],[375,95],[450,100],[525,97],[600,92]], color:[226,97,63], callout:'never fully stops'}
};
const flipLine = document.getElementById('flipLine');
const flipCallout = document.getElementById('flipCallout');
let flipCurrentKey = 'healthy';
let flipMorphing = false;
function easeInOutCubic(t){ return t<0.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
function rgbStr(c){ return `rgb(${c[0]},${c[1]},${c[2]})`; }
function drawFlipStatic(key){
  const d = flipData[key];
  flipLine.setAttribute('d', catmullRom2bezier(d.pts));
  flipLine.setAttribute('stroke', rgbStr(d.color));
  const peakPt = d.pts.reduce((a,b)=> b[1]<a[1]?b:a);
  flipCallout.setAttribute('x', peakPt[0]);
  flipCallout.setAttribute('y', peakPt[1]-12);
  flipCallout.setAttribute('fill', rgbStr(d.color));
  flipCallout.textContent = d.callout;
  flipCallout.style.opacity = 1;
}
function morphFlip(toKey, duration){
  if(flipMorphing || toKey===flipCurrentKey) return;
  flipMorphing = true;
  const from = flipData[flipCurrentKey];
  const to = flipData[toKey];
  flipCallout.style.transition = 'opacity .25s ease';
  flipCallout.style.opacity = 0;
  const start = performance.now();
  function frame(now){
    const t = Math.min(1, (now-start)/duration);
    const e = easeInOutCubic(t);
    const pts = from.pts.map((p,i)=> [p[0], p[1] + (to.pts[i][1]-p[1])*e]);
    const col = from.color.map((c,i)=> Math.round(c + (to.color[i]-c)*e));
    flipLine.setAttribute('d', catmullRom2bezier(pts));
    flipLine.setAttribute('stroke', rgbStr(col));
    if(t<1){ requestAnimationFrame(frame); }
    else{
      flipCurrentKey = toKey;
      const peakPt = to.pts.reduce((a,b)=> b[1]<a[1]?b:a);
      flipCallout.setAttribute('x', peakPt[0]);
      flipCallout.setAttribute('y', peakPt[1]-12);
      flipCallout.setAttribute('fill', rgbStr(to.color));
      flipCallout.textContent = to.callout;
      flipCallout.style.opacity = 1;
      flipMorphing = false;
    }
  }
  requestAnimationFrame(frame);
}
drawFlipStatic('healthy');
document.querySelectorAll('.toggle button').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    if(flipMorphing || btn.classList.contains('active')) return;
    document.querySelectorAll('.toggle button').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    morphFlip(btn.dataset.pattern, 900);
  });
});
/* auto-demo: once this section is in view, slowly morph healthy -> common to tell the story unprompted */
const flipDemoEl = document.querySelector('#flip .curve-card');
const flipDemoIO = new IntersectionObserver((entries)=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting){
      flipDemoIO.unobserve(entry.target);
      setTimeout(()=>{
        morphFlip('common', 3200);
        document.querySelectorAll('.toggle button').forEach(b=> b.classList.toggle('active', b.dataset.pattern==='common'));
      }, 1400);
    }
  });
}, {threshold:0.6});
flipDemoIO.observe(flipDemoEl);

/* ---------------- HOW IT WORKS ---------------- */
const formulas = {
  am: {
    accentClass:'', pmClass:false,
    timeline:[['💊','Capsule','0 min'],['❤','Absorption','20–30 min'],['🩸','Bloodstream','30–60 min'],['🛡','Blood–Brain','45–90 min'],['🧠','Active Site','peak 2–4 hr']],
    ingredients:[
      {name:'L-Theanine', desc:'Increases alpha brain-wave activity and shapes GABA and glutamate signaling — the pattern associated with calm, focused alertness rather than sedation.', dots:{pre:2, post:1}},
      {name:'Ashwagandha', desc:'Engages the hypothalamus, the control centre of the HPA axis, and is studied for its role in moderating cortisol output at the source.', dots:{pre:0, post:1}},
      {name:'Rhodiola Rosea', desc:'Influences serotonin and dopamine signaling involved in stress resilience and the body\u2019s response to mental fatigue.', dots:{pre:2, post:1}},
      {name:'Maca Root', desc:'Supports adrenal energy metabolism and healthy hormone balance, contributing to steadier energy through the day.', dots:{pre:1, post:1}},
      {name:'Black Pepper', desc:'Slows the enzymes that would otherwise break the other actives down early, extending how long they stay available at the synapse.', dots:{pre:0, post:0, cleft:true}}
    ]
  },
  pm: {
    timeline:[['💊','Capsule','0 min'],['❤','Absorption','20–30 min'],['🩸','Bloodstream','30–60 min'],['🛡','Blood–Brain','45–90 min'],['🧠','Active Site','peak 1–2 hr']],
    ingredients:[
      {name:'Magnesium', desc:'Acts as a natural regulator of NMDA receptors, quieting excitatory signaling as the evening progresses.', dots:{pre:1, post:0}},
      {name:'GABA', desc:'The brain\u2019s primary inhibitory neurotransmitter — directly dampens neural excitability to ease the transition into rest.', dots:{pre:0, post:2}},
      {name:'L-Tryptophan', desc:'A precursor to serotonin and melatonin, feeding the pathway that governs the body\u2019s sleep–wake switch.', dots:{pre:1, post:1}},
      {name:'Valerian Root', desc:'Increases GABA availability at the synapse, similar in mechanism to how the body naturally sedates itself for sleep.', dots:{pre:0, post:2}},
      {name:'Chamomile', desc:'Binds to some of the same receptor sites as common anti-anxiety compounds, producing a mild calming effect.', dots:{pre:1, post:0}},
      {name:'Passionflower', desc:'Raises GABA levels in the brain, associated with quieter mental chatter before sleep.', dots:{pre:0, post:1}}
    ]
  }
};
let currentFormula = 'am';
let currentIngredientIdx = 0;

const pillRow = document.getElementById('ingredientPills');
const routeWaypoints = document.getElementById('routeWaypoints');
const routePathEl = document.getElementById('routePath');
const routePulseEl = document.getElementById('routePulse');
const routeGlowEl = document.getElementById('routeGlow');
const synName = document.getElementById('synapseIngName');
const synDesc = document.getElementById('synapseDesc');
const synDots = document.getElementById('synDots');

function renderFormula(){
  const f = formulas[currentFormula];
  const pmMode = currentFormula==='pm';
  pillRow.innerHTML='';
  f.ingredients.forEach((ing,i)=>{
    const b = document.createElement('button');
    b.className = 'pill' + (i===currentIngredientIdx ? ' active'+(pmMode?' pm-active':'') : '');
    b.textContent = ing.name;
    b.addEventListener('click', ()=>{ currentIngredientIdx=i; renderFormula(); });
    pillRow.appendChild(b);
  });
  routeWaypoints.innerHTML='';
  const pathLen = routePathEl.getTotalLength();
  const fracs = [0, 0.24, 0.5, 0.76, 1];
  f.timeline.forEach(([ic,name,val], i)=>{
    const pt = routePathEl.getPointAtLength(fracs[i]*pathLen);
    const leftPct = (pt.x/340*100).toFixed(2);
    const topPct = (pt.y/200*100).toFixed(2);
    const el = document.createElement('div');
    el.className = 'waypoint' + (pmMode ? ' pm-wp' : '');
    el.style.left = leftPct+'%';
    el.style.top = topPct+'%';
    if(i===0) el.style.transform = 'translate(-6%,-50%)';
    else if(i===fracs.length-1) el.style.transform = 'translate(-94%,-50%)';
    el.innerHTML = `<div class="ic">${ic}</div><div class="wname">${name}</div><span class="wval">${val}</span>`;
    routeWaypoints.appendChild(el);
  });
  const pulseColor = pmMode ? '#93a9c9' : '#d9a441';
  routePulseEl.setAttribute('fill', pulseColor);
  routeGlowEl.setAttribute('fill', pulseColor);
  const ing = f.ingredients[currentIngredientIdx];
  synName.style.opacity = 0; synDesc.style.opacity = 0;
  setTimeout(()=>{
    synName.textContent = ing.name;
    synDesc.textContent = ing.desc;
    synName.style.opacity = 1; synDesc.style.opacity = 1;
  }, 120);
  synDots.innerHTML='';
  const preDotPos=[[78,58],[86,78],[76,98]];
  const postDotPos=[[242,58],[234,78],[244,98]];
  function addVesicle(x,y,lit){
    const color = pmMode?'#93a9c9':'#d9a441';
    if(lit){
      const halo = document.createElementNS('http://www.w3.org/2000/svg','circle');
      halo.setAttribute('cx',x); halo.setAttribute('cy',y); halo.setAttribute('r',9);
      halo.setAttribute('fill',color); halo.setAttribute('opacity','.28');
      halo.setAttribute('filter','url(#softGlow)');
      synDots.appendChild(halo);
    }
    const c = document.createElementNS('http://www.w3.org/2000/svg','circle');
    c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', lit?5:3);
    c.setAttribute('fill', lit ? color : '#3a2f1e');
    synDots.appendChild(c);
  }
  for(let i=0;i<3;i++) addVesicle(preDotPos[i][0], preDotPos[i][1], i < ing.dots.pre);
  for(let i=0;i<3;i++) addVesicle(postDotPos[i][0], postDotPos[i][1], i < ing.dots.post);
  if(ing.dots.cleft) addVesicle(155, 78, true);
  const ntTravel = document.getElementById('ntTravel');
  const apTravel = document.getElementById('apTravel');
  const nColor = pmMode?'#93a9c9':'#d9a441';
  if(ntTravel) ntTravel.setAttribute('fill', nColor);
  if(apTravel) apTravel.setAttribute('fill', nColor);
  document.querySelectorAll('.receptors path').forEach(p=> p.style.stroke = nColor);
  const preBody = document.getElementById('neuronPreBody');
  const postBody = document.getElementById('neuronPostBody');
  const bodyFill = pmMode ? 'url(#neuronBodyPM)' : 'url(#neuronBodyAM)';
  if(preBody) preBody.setAttribute('fill', bodyFill);
  if(postBody) postBody.setAttribute('fill', bodyFill);
}
renderFormula();

document.querySelectorAll('.formula-toggle button').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    document.querySelectorAll('.formula-toggle button').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    currentFormula = btn.dataset.formula;
    currentIngredientIdx = 0;
    renderFormula();
  });
});

/* ---------------- WHY IT MATTERS WHEEL ---------------- */
const wheelData = [
  {key:'cellular', label:'CELLULAR', angle:-90, title:'Cellular Recovery', desc:'Deep sleep is when the body does most of its repair work — cut it short and that recovery window shrinks.', icon:'M12 2v4M12 18v4M4.2 4.2l2.8 2.8M17 17l2.8 2.8M2 12h4M18 12h4M4.2 19.8l2.8-2.8M17 7l2.8-2.8'},
  {key:'immune', label:'IMMUNE', angle:-30, title:'Immune Signalling', desc:'Chronic cortisol elevation can blunt immune signalling, leaving the body slower to bounce back from everyday illness.', icon:'M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3z'},
  {key:'metabolic', label:'METABOLIC', angle:30, title:'Metabolic Balance', desc:'Disrupted cortisol rhythms are linked to blood sugar swings and changes in appetite regulation.', icon:'M12 2a10 10 0 100 20 10 10 0 000-20zM12 6v6l4 2'},
  {key:'cardiovascular', label:'HEART', angle:90, title:'Cardiovascular Strain', desc:'Ongoing stress-hormone elevation is linked to higher blood pressure and added strain on the cardiovascular system.', icon:'M3 12h4l2 6 4-12 2 6h6'},
  {key:'cognitive', label:'COGNITIVE', angle:150, title:'Memory & Focus', desc:'Sleep loss impairs the hippocampus\u2019s ability to consolidate memory, showing up as fog and forgetfulness.', icon:'M9 18h6M10 21h4M12 3a6 6 0 00-4 10.5c.6.6 1 1.3 1 2.5h6c0-1.2.4-1.9 1-2.5A6 6 0 0012 3z'},
  {key:'mood', label:'MOOD', angle:210, title:'Emotional Regulation', desc:'As covered in the anxiety loop, poor sleep is tied to reduced emotional regulation and increased reactivity.', icon:'M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01M12 2a10 10 0 100 20 10 10 0 000-20z'}
];
const wheelNodesG = document.getElementById('wheelNodes');
const detailCard = document.getElementById('detailCard');
const CX=180, CY=160, R=120, NODER=84;

function renderWheel(selectedKey){
  wheelNodesG.innerHTML='';
  wheelData.forEach(d=>{
    const rad = d.angle*Math.PI/180;
    const nx = CX + NODER*Math.cos(rad);
    const ny = CY + NODER*Math.sin(rad);
    const g = document.createElementNS('http://www.w3.org/2000/svg','g');
    g.setAttribute('class','wheel-node'+(d.key===selectedKey?' selected':''));

    const line = document.createElementNS('http://www.w3.org/2000/svg','line');
    line.setAttribute('x1',CX); line.setAttribute('y1',CY);
    line.setAttribute('x2',nx); line.setAttribute('y2',ny);
    line.setAttribute('stroke', d.key===selectedKey ? '#e2613f' : 'rgba(244,239,228,.08)');
    line.setAttribute('stroke-width','1');
    g.appendChild(line);

    const hit = document.createElementNS('http://www.w3.org/2000/svg','circle');
    hit.setAttribute('cx',nx); hit.setAttribute('cy',ny); hit.setAttribute('r',22);
    hit.setAttribute('class','hit');
    g.appendChild(hit);

    const dot = document.createElementNS('http://www.w3.org/2000/svg','circle');
    dot.setAttribute('cx',nx); dot.setAttribute('cy',ny); dot.setAttribute('r',7);
    dot.setAttribute('class','dot');
    g.appendChild(dot);

    const tx = CX + (NODER+20)*Math.cos(rad);
    const ty = CY + (NODER+20)*Math.sin(rad);
    const text = document.createElementNS('http://www.w3.org/2000/svg','text');
    text.setAttribute('x',tx); text.setAttribute('y',ty);
    text.setAttribute('text-anchor', Math.cos(rad)>0.3?'start':(Math.cos(rad)<-0.3?'end':'middle'));
    text.textContent = d.label;
    g.appendChild(text);

    g.addEventListener('click', ()=>{ renderWheel(d.key); renderDetail(d.key); });
    wheelNodesG.appendChild(g);
  });
}
function renderDetail(key){
  const d = wheelData.find(w=>w.key===key);
  detailCard.style.opacity = 0;
  setTimeout(()=>{
    detailCard.innerHTML = `
      <div class="ic"><svg viewBox="0 0 24 24"><path d="${d.icon}"/></svg></div>
      <h3>${d.title}</h3>
      <p>${d.desc}</p>
    `;
    detailCard.style.opacity = 1;
  }, 160);
}
renderWheel('cardiovascular');
renderDetail('cardiovascular');

/* ---------------- REVEAL-ON-SCROLL SYSTEM ---------------- */
function staggerGroup(containerSel, ms){
  document.querySelectorAll(containerSel).forEach(container=>{
    Array.from(container.children).forEach((child,i)=>{
      if(child.classList && child.classList.contains('reveal')){
        child.style.transitionDelay = (i*ms)+'ms';
      }
    });
  });
}
staggerGroup('#contribGrid', 90);
staggerGroup('.week-strip', 110);
staggerGroup('.formula-cards', 140);

const revealIO = new IntersectionObserver((entries)=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting){
      entry.target.classList.add('in-view');
      revealIO.unobserve(entry.target);
    }
  });
}, {threshold:0.15, rootMargin:'0px 0px -60px 0px'});

document.querySelectorAll('.reveal:not(.load-reveal)').forEach(el=> revealIO.observe(el));

/* hero elements reveal immediately on load rather than waiting for scroll */
window.addEventListener('load', ()=>{
  document.querySelectorAll('.load-reveal').forEach((el,i)=>{
    setTimeout(()=> el.classList.add('in-view'), 80 + i*120);
  });
});

/* ---------------- WEEK-STRIP SPARKLINES: morph from a flat line into shape ---------------- */
const weekSparkShapes = [
  {flat:[[2,24],[20,24],[38,24],[56,24],[72,24]], curve:[[2,24],[20,10],[38,18],[56,28],[72,20]]},
  {flat:[[2,20],[20,20],[38,20],[56,20],[72,20]], curve:[[2,20],[20,12],[38,15],[56,19],[72,17]]},
  {flat:[[2,24],[20,24],[38,24],[56,24],[72,24]], curve:[[2,24],[16,6],[34,13],[54,26],[72,27]]}
];
function morphPath(pathEl, fromPts, toPts, duration){
  const start = performance.now();
  function frame(now){
    const t = Math.min(1, (now-start)/duration);
    const e = easeInOutCubic(t);
    const pts = fromPts.map((p,i)=> [p[0], p[1] + (toPts[i][1]-p[1])*e]);
    pathEl.setAttribute('d', catmullRom2bezier(pts));
    if(t<1) requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
}
const weekSparkEls = document.querySelectorAll('.week-spark');
weekSparkEls.forEach((el,i)=> el.setAttribute('d', catmullRom2bezier(weekSparkShapes[i].flat)));
const weekRows = document.querySelectorAll('.week-row');
const weekIO = new IntersectionObserver((entries)=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting){
      weekIO.unobserve(entry.target);
      const idx = Array.from(weekRows).indexOf(entry.target);
      setTimeout(()=> morphPath(weekSparkEls[idx], weekSparkShapes[idx].flat, weekSparkShapes[idx].curve, 1300), 150);
    }
  });
}, {threshold:0.5});
weekRows.forEach(row=> weekIO.observe(row));

})();

  } catch(e) { console.error(e); }
})();
})();
